module.exports = __webpack_public_path__ + "assets/img/pages/certificate/certificate_obagi_2_thumb.png?5941";


//////////////////
// WEBPACK FOOTER
// ./assets/img/pages/certificate/certificate_obagi_2_thumb.png
// module id = 21
// module chunks = 0